import { SinglePaymentResult } from '@mews-commander/data-access';
import { formatExchangeRateLabel } from '@mews/business-components';
import { CustomErrorParams, CustomErrorType, DecimalService } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export const getNormalizedData = (data: SinglePaymentResult) => {
    const { foreignExchangePaymentDetail, refundableValue, customerId, chargeAmount, refundMode } = data || {};
    const { chargeConversionRate, refundConversionRate, refundConversionMultiplier, propertyCurrencyChargeAmount } =
        foreignExchangePaymentDetail || {};

    return {
        refundableValue,
        chargeAmount,
        customerId,
        refundConversionMultiplier: refundConversionMultiplier || 1,
        propertyCurrencyChargeAmount: propertyCurrencyChargeAmount || {
            currencyCode: '',
            value: 0,
        },
        propertyCurrencyRefundAmount: {
            value: roundToTwoDecimals(refundableValue * Number(refundConversionMultiplier)),
            currencyCode: propertyCurrencyChargeAmount?.currencyCode || '',
        },
        chargeConversionRate: formatExchangeRateLabel({
            toCurrency: chargeConversionRate?.toCurrency,
            fromCurrency: chargeConversionRate?.fromCurrency,
        }),
        refundConversionRate: formatExchangeRateLabel({
            toCurrency: refundConversionRate?.toCurrency,
            fromCurrency: refundConversionRate?.fromCurrency,
        }),
        refundMode,
    };
};

export const roundToTwoDecimals = (value?: number) => {
    if (!value) {
        return 0;
    }

    return DecimalService.toNumber(DecimalService.round(DecimalService.parse(value), 2));
};

export const getCustomMinErrorParams = (amount: number) =>
    ({
        errorType: CustomErrorType.Other,
        textKey: TextKey.PaymentRefundErrorMinAmount,
        substitutes: {
            amount,
        },
    }) satisfies CustomErrorParams;
